<template>
    <div class="shared_popup_wrp">
  <div class="shared_popup_center_popup">
    <div class="shared_popup_modal">
      <div class="shared_popup_header">
        <h3 class="shared_popup_heading">Notes Share</h3>
        <span class="shared_popup_close">
          <i class="fa fa-times" aria-hidden="true" v-on:click="sharedNotesPopupDisabledFun()"></i>
        </span>
      </div>
      <div class="shared_popup_body">
        <form @submit.prevent="sharedNotesMethod">
          <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control" readonly v-model="name">
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Select Option</label>
                <ul class="optional_list_wrp">
                  <li>
                    <input type="radio" id="User" name="type" v-model="selection_type" value="User"
                      v-on:click="selectedOptionMethod('User')" checked>
                    <label for="User">User</label>
                  </li>
                  <li>
                    <input type="radio" id="Group" name="type" v-model="selection_type" value="Group"
                      v-on:click="selectedOptionMethod('Group')">
                    <label for="Group">Group</label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="form-group multiselect_dropdown_ui" v-if="selection_type === 'User'">
            <label>User</label>
            <multiselect v-model="users" placeholder="Select User" label="email" track-by="email" :options="options"
              :option-height="104" :custom-label="customLabel" :show-labels="true" :multiple="true" :taggable="true"
              @tag="addTag" v-validate="'required'" v-bind:class="{'is-invalid': errors.has('users') }" name="users">
            </multiselect>
            <small class="invalid-feedback" v-if="errors.has('users')">{{ errors.first('users') }}</small>
          </div>
          <div class="form-group multiselect_dropdown_ui" v-if="selection_type === 'Group'">
            <label>Group</label>
            <multiselect v-model="users" placeholder="Select Group" label="gName" track-by="gName"
              :options="groupOptions" :option-height="104" :custom-label="customGroupLabel" :show-labels="true"
              :multiple="false" :taggable="true" @tag="addTag" v-validate="'required'"
              v-bind:class="{'is-invalid': errors.has('users') }" name="users">
            </multiselect>
            <small class="invalid-feedback" v-if="errors.has('users')">{{ errors.first('users') }}</small>
          </div>
          <div class="form-group">
            <label>Write Access</label>
            <div class="write_access_toggle">
              <div class="onoffswitch text-left">
                <input type="checkbox" v-model="write_access" id="writeAccess" class="onoffswitch-checkbox">
                <label class="onoffswitch-label" for="writeAccess"><span class="onoffswitch-inner"></span><span class="onoffswitch-switch"></span></label>
              </div>
            </div>
          </div>
          <div class="form-group mb-0">
            <button type="submit" class="btn btn-primary" :disabled="submitted">Share</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/*eslint-disable */

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import {
  bus
} from '@/main';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'shared-notes',
  components: {Multiselect},
  props: ['sharedNotesINFO'],
  data () {
    return {
      submitted:false,
      userList:null,
      userListResults:[], 
      options:[],
      name:'',
      sentUserData:[],
      users:[],
      sharedNotesId:'',
      selection_type:'User',
      groupUserList:null,
      groupUserListResults:[],
      groupOptions:[],
      write_access:false
    }
  },
  computed: {

  },
  mounted () {
    this.getAllUserListMethod()
    this.name = this.sharedNotesINFO.title
    this.sharedNotesId = this.sharedNotesINFO.id
  },
  methods: {
    selectedOptionMethod(item){
      this.users = []
      this.sentUserData = []
      this.$validator.reset()
      this.selection_type = item
      if(item === 'User') return
      if(this.groupUserList) return;
      this.$store.dispatch('getGroupChatRoomCreatedFun').then((res) => {
        this.groupUserList = res.data.data
        if(this.groupUserList != undefined){
          this.groupUserListResults = this.groupUserList
          for(var i = 0; i < this.groupUserListResults.length; i++){
            this.groupOptions.push({gName:this.groupUserListResults[i].name, id : this.groupUserListResults[i].id})
          }
        }
      })
    },
    getAllUserListMethod() {
     this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
       this.userList = res.data.data
       if(this.userList != undefined){
         this.userListResults = this.userList
         for(var i = 0; i < this.userListResults.length; i++){
           this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
         }
       }
     }).catch((err)=>{})
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.users.push(tag) 
    },
    customGroupLabel ({ gName }) {
      return `${gName}`
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    sharedNotesMethod(){
      this.sentUserData = []
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          if(this.selection_type === 'User'){
            for(var i = 0; i < this.users.length; i++){
              this.sentUserData.push(this.users[i].id)
            }
            var data = {
              user_notes:this.sharedNotesId,
              user:this.sentUserData,
              write_access:this.write_access
            }
            this.$store.dispatch('newNotesSharedFun', data)
              .then((res) => { 
                toast.success(res.data.msg);
                this.submitted =  false
                this.sharedNotesPopupDisabledFun()
              }).catch((err) => {
                toast.error(err.data.msg);
                this.submitted =  false
              })
              return;
          }else{
            var data = {
              user_notes:this.sharedNotesId,
              chat_room:this.users.id,
              write_access:this.write_access
            }
            this.$store.dispatch('createNotesSharedInGroupFun', data)
              .then((res) => { 
                toast.success(res.data.msg);
                this.submitted =  false
                this.sharedNotesPopupDisabledFun()
              }).catch((err) => {
                toast.error(err.data.msg);
                this.submitted =  false
              })
              return;
          }
        }
      })
    },
    sharedNotesPopupDisabledFun(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('sharedNotesBus', false);
      this.sentUserData = []
      this.sharedNotesId = ''
      this.name = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.shared_popup_wrp {position: fixed;top: 0;bottom: 0;left: 0;right: 0;z-index: 1000;background: rgba(0, 0, 0, 0.92);display: table;width: 100%;height: 100%;font-family: 'MyriadProRegular','Lato',sans-serif;color: #ffffff;}.shared_popup_wrp .shared_popup_center_popup {display: table-cell;vertical-align: middle;}.shared_popup_wrp .shared_popup_modal {background: #000;max-width: 520px;margin: 0 auto;border-radius: 5px;-webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);}.shared_popup_wrp .shared_popup_close {position: absolute;top: 15px;right: 10px;line-height: 1;}.shared_popup_wrp .shared_popup_close .fa {font-size: 20px;color: red;cursor: pointer;transform: scale(1);-webkit-transform: scale(1);-moz-transform: scale(1);-webkit-transition: all ease 0.5s;transition: all ease 0.5s;&:hover{color:#87cefa;}}.shared_popup_wrp .shared_popup_header {padding: 15px;position: relative;border-bottom: 1px solid rgba(255, 255, 255, 0.2);}.shared_popup_wrp .shared_popup_header .shared_popup_heading {font-size: 24px;letter-spacing: 0;margin-bottom: 0;}.shared_popup_wrp .shared_popup_body {padding: 15px;}.shared_popup_wrp .shared_popup_body label {font-size: 18px;margin-bottom: 4px;color: #fffce8;}.shared_popup_wrp .shared_popup_body .optional_list_wrp label {font-size: 16px;color: #ffffff;}.shared_popup_wrp .shared_popup_body .form-control {height: auto;padding: 7px 15px;background: rgba(255, 255, 255, 0.1);border-color: transparent;font-size: 16px;color: #fff;font-family: 'MyriadProRegular','Lato',sans-serif;-webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);outline: none;box-shadow: none;}.shared_popup_wrp .shared_popup_body .invalid-feedback {font-size: 14px;line-height: 1;}.shared_popup_wrp .shared_popup_body .btn-primary {cursor: pointer;position: relative;min-width: 95px;-webkit-box-shadow: none;box-shadow: none;outline: none;background: rgba(255, 255, 255, 0.12);color: #ffffff;border: none;border-radius: 3px;font-family: 'MyriadProRegular','Lato',sans-serif;font-size: 18px;}.shared_popup_wrp .shared_popup_body .btn-primary:hover {background: #87cefa;color: #22292f;}.shared_popup_wrp .optional_list_wrp {margin: 0 0 20px;padding: 0;list-style: none;display: flex;align-items: center;}.shared_popup_wrp .optional_list_wrp li {margin-right: 15px;}.shared_popup_wrp .optional_list_wrp li input {cursor: pointer;}.shared_popup_wrp .optional_list_wrp li label {margin-left: 5px;margin-bottom: 0px;cursor: pointer;}
/* Toggle button styles */
.write_access_toggle{
.onoffswitch {
position: relative;
width:55px;
-webkit-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
}
.onoffswitch-checkbox {
display: none;
}
.onoffswitch-label {
display: block;
overflow: hidden;
cursor: pointer;
border: 0px solid #999999;
border-radius: 20px;
margin: 0;
}
.onoffswitch-inner {
display: block;
width: 200%;
margin-left: -100%;
transition: margin 0.3s ease-in 0s;
}
.onoffswitch-inner:before, .onoffswitch-inner:after {
display: block;
float: left;
width: 50%;
height: 25px;
padding: 0;
line-height: 25px;
font-size: 14px;
color: white;
font-weight: 400;
box-sizing: border-box;
}
.onoffswitch-inner:before {
content:"Yes";
padding-left: 10px;
background-color: #36B04C;
color: #FFFFFF;
}
.onoffswitch-inner:after {
content:"No";
padding-right: 10px;
background-color: #DA1B22;
color: #FFFFFF;
text-align: right;
}
.onoffswitch-switch {
display: block;
width: 17px;
margin: 4px;
background: #FFFFFF;
position: absolute;
top: 0;
bottom: 0;
right:29px;
border: 0px solid #999999;
border-radius: 13px;
transition: all 0.3s ease-in 0s;
}
.onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
margin-left: 0;
}
.onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
right: 0px;
}
}
</style>